import Loadable from 'react-loadable';

import { LoadingPage } from 'src/components/react-loadable';

export const MergeQueuesLoadable = Loadable<any, never>({
  loading: LoadingPage,
  loader: () => import('./merge-queues'),
});
